import { MethodologyCluster } from './models';
import { UUID } from '../app/basicModels';

const actions = {
  SET_METHODOLOGY_CLUSTERS: '[MethodologyCluster] Set Methodology Clusters',
  ADD_METHODOLOGY_CLUSTER: '[MethodologyCluster] Add Methodology Cluster',
  ADD_CLONED_CLUSTERS: '[MethodologyCluster] Add Cloned Clusters',
  UPDATE_METHODOLOGY_CLUSTER: '[MethodologyCluster] Update Methodology Cluster',
  REMOVE_METHODOLOGY_CLUSTER: '[MethodologyCluster] Remove Methodology Cluster',
  REMOVE_COMPONENT_FROM_CLUSTER: '[MethodologyCluster] Remove Component From Cluster',
  REMOVE_CLUSTERS_BY_PHENOMENON_ID: '[MethodologyCluster] Remove Clusters By Phenomenon ID',

  setMethodologyClusters: (clusters: MethodologyCluster[]) => ({
    type: actions.SET_METHODOLOGY_CLUSTERS,
    payload: clusters
  }),

  addMethodologyCluster: (cluster: MethodologyCluster) => ({
    type: actions.ADD_METHODOLOGY_CLUSTER,
    payload: cluster
  }),

  addClonedClusters: (clusters: MethodologyCluster[]) => ({
    type: actions.ADD_CLONED_CLUSTERS,
    payload: clusters
  }),

  updateMethodologyCluster: (cluster: MethodologyCluster) => ({
    type: actions.UPDATE_METHODOLOGY_CLUSTER,
    payload: cluster
  }),

  removeMethodologyCluster: (id: UUID) => ({
    type: actions.REMOVE_METHODOLOGY_CLUSTER,
    payload: id
  }),

  removeComponentFromCluster: (componentId?: string) => ({
    type: actions.REMOVE_COMPONENT_FROM_CLUSTER,
    payload: componentId
  }),

  removeClustersByPhenomenonId: (phenomenonId: UUID) => ({
    type: actions.REMOVE_CLUSTERS_BY_PHENOMENON_ID,
    payload: phenomenonId
  })
};

export default actions;
